import { Check, CircleAlert, Loader2 } from "lucide-react"
import type { AutoSaveStatus } from "@/hooks/useAutoSaveDraft"

/** Kleiner Status-Hinweis neben Reply-Headern — Gmail-Style. */
export function AutoSaveIndicator({
  status,
  savedAt,
}: {
  status: AutoSaveStatus
  savedAt: Date | null
}) {
  if (status === "idle") return null

  const base = "inline-flex items-center gap-1 text-[11px] leading-none whitespace-nowrap"

  if (status === "dirty") {
    return <span className={`${base} text-slate-400`}>Aenderungen…</span>
  }
  if (status === "saving") {
    return (
      <span className={`${base} text-slate-500`}>
        <Loader2 className="w-3 h-3 animate-spin" /> Speichere…
      </span>
    )
  }
  if (status === "error") {
    return (
      <span className={`${base} text-red-500`}>
        <CircleAlert className="w-3 h-3" /> Speichern fehlgeschlagen
      </span>
    )
  }
  // saved
  return (
    <span className={`${base} text-emerald-600`}>
      <Check className="w-3 h-3" /> {savedAt ? `Gespeichert ${formatTime(savedAt)}` : "Gespeichert"}
    </span>
  )
}

function formatTime(d: Date): string {
  return d.toLocaleTimeString("de-DE", { hour: "2-digit", minute: "2-digit" })
}
